"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedMarkers = void 0;
const markerclusterer_1 = require("@googlemaps/markerclusterer");
const react_google_maps_1 = require("@vis.gl/react-google-maps");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const clusterSlice_1 = require("../../../../store/clusterSlice");
const fixedStreamSelectors_1 = require("../../../../store/fixedStreamSelectors");
const hooks_1 = require("../../../../store/hooks");
const mapSlice_1 = require("../../../../store/mapSlice");
const markersLoadingSlice_1 = require("../../../../store/markersLoadingSlice");
const thresholdSlice_1 = require("../../../../store/thresholdSlice");
const getClusterPixelPosition_1 = require("../../../../utils/getClusterPixelPosition");
const mapEventListeners_1 = __importDefault(require("../../../../utils/mapEventListeners"));
const mapParamsHandler_1 = require("../../../../utils/mapParamsHandler");
const thresholdColors_1 = require("../../../../utils/thresholdColors");
const ClusterInfo_1 = require("./ClusterInfo/ClusterInfo");
const userStates_1 = require("../../../../types/userStates");
const HoverMarker_1 = __importDefault(require("./HoverMarker/HoverMarker"));
const clusterCalculations_1 = require("./ClusterMarker/clusterCalculations");
const clusterOverlay_1 = require("./ClusterMarker/clusterOverlay");
const customMarkerLabel_1 = require("./CustomOverlays/customMarkerLabel");
const customMarkerOverlay_1 = require("./CustomOverlays/customMarkerOverlay");
const gridClusterAlgorithm_1 = require("./gridClusterAlgorithm");
const ZOOM_FOR_SELECTED_SESSION = 15;
function FixedMarkers({ sessions, onMarkerClick, selectedStreamId, pulsatingSessionId, onClusterClick, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, hooks_1.useAppDispatch)();
    const { unitSymbol, currentUserSettings } = (0, mapParamsHandler_1.useMapParams)();
    const map = (0, react_google_maps_1.useMap)();
    const calculatingText = t("map.calculating");
    // Redux selectors
    const hoverStreamId = (0, hooks_1.useAppSelector)(mapSlice_1.selectHoverStreamId);
    const thresholds = (0, hooks_1.useAppSelector)(thresholdSlice_1.selectThresholds);
    const clusterVisible = (0, hooks_1.useAppSelector)((state) => state.cluster.visible);
    const fixedStreamData = (0, hooks_1.useAppSelector)(fixedStreamSelectors_1.selectFixedStreamData);
    const fixedStreamStatus = (0, hooks_1.useAppSelector)(fixedStreamSelectors_1.selectFixedStreamStatus);
    const clusterAverage = (0, hooks_1.useAppSelector)((state) => state.cluster.clusterAverage);
    const clusterSize = (0, hooks_1.useAppSelector)((state) => state.cluster.clusterSize);
    // Refs
    const clustererRef = (0, react_1.useRef)(null);
    const markerRefs = (0, react_1.useRef)(new Map());
    const markerOverlays = (0, react_1.useRef)(new Map());
    const labelOverlays = (0, react_1.useRef)(new Map());
    const clusterOverlaysRef = (0, react_1.useRef)(new Map());
    const previousZoomRef = (0, react_1.useRef)(null);
    const initialCenterRef = (0, react_1.useRef)(false);
    // State variables
    const [hoverPosition, setHoverPosition] = (0, react_1.useState)(null);
    const [selectedCluster, setSelectedCluster] = (0, react_1.useState)(null);
    const [clusterPosition, setClusterPosition] = (0, react_1.useState)(null);
    const [clusterDataLoading, setClusterDataLoading] = (0, react_1.useState)(false);
    // Memoized values
    const memoizedSessions = (0, react_1.useMemo)(() => sessions, [sessions]);
    const isLoading = (0, hooks_1.useAppSelector)(fixedStreamSelectors_1.selectIsLoading);
    // Refs for event handlers
    const onMarkerClickRef = (0, react_1.useRef)(onMarkerClick);
    (0, react_1.useEffect)(() => {
        onMarkerClickRef.current = onMarkerClick;
        initialCenterRef.current = false;
    }, [onMarkerClick]);
    // Utility functions
    const centerMapOnMarker = (0, react_1.useCallback)((position) => {
        if (map) {
            map.panTo(position);
            map.setZoom(ZOOM_FOR_SELECTED_SESSION);
        }
    }, [map]);
    const handleClusterClickInternal = (0, react_1.useCallback)((event, cluster) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        dispatch((0, clusterSlice_1.setVisibility)(false));
        if (map) {
            const pixelPosition = (0, getClusterPixelPosition_1.getClusterPixelPosition)(map, cluster.position);
            setClusterPosition({ top: pixelPosition.y, left: pixelPosition.x });
        }
        setClusterDataLoading(true);
        setSelectedCluster(cluster);
        if (cluster.markers) {
            const average = (0, clusterCalculations_1.calculateClusterAverage)(cluster.markers);
            dispatch((0, clusterSlice_1.setAverage)(average));
            dispatch((0, clusterSlice_1.setSize)(((_a = cluster.markers) === null || _a === void 0 ? void 0 : _a.length) || 0));
        }
        setClusterDataLoading(false);
        dispatch((0, clusterSlice_1.setVisibility)(true));
        onClusterClick === null || onClusterClick === void 0 ? void 0 : onClusterClick(cluster);
    }), [dispatch, map, onClusterClick]);
    const handleClusteringEnd = (0, react_1.useCallback)(() => {
        var _a;
        const currentZoom = (_a = map === null || map === void 0 ? void 0 : map.getZoom()) !== null && _a !== void 0 ? _a : null;
        if (currentZoom === previousZoomRef.current) {
            return;
        }
        previousZoomRef.current = currentZoom;
        markerRefs.current.forEach((marker) => {
            marker.clustered = false;
        });
        const clusters = clustererRef.current &&
            // @ts-ignore - clusters
            clustererRef.current.clusters;
        clusterOverlaysRef.current.forEach((overlay) => {
            overlay.setMap(null);
        });
        clusterOverlaysRef.current.clear();
        if (!clusters)
            return;
        const bounds = map === null || map === void 0 ? void 0 : map.getBounds();
        clusters.forEach((cluster) => {
            if (cluster.markers &&
                cluster.markers.length > 1 &&
                (bounds === null || bounds === void 0 ? void 0 : bounds.contains(cluster.position))) {
                cluster.markers.forEach((marker) => {
                    marker.clustered = true;
                });
                const markers = cluster.markers;
                const values = markers.map((marker) => marker.value || 0);
                const average = values.reduce((sum, value) => sum + value, 0) / values.length;
                const color = (0, thresholdColors_1.getColorForValue)(thresholds, average);
                const hasPulsatingSession = pulsatingSessionId !== null &&
                    markers.some((marker) => marker.sessionId === pulsatingSessionId);
                const overlay = new ((0, clusterOverlay_1.getClusterOverlayClass)())(cluster, color, hasPulsatingSession, map, handleClusterClickInternal);
                const clusterKey = `${cluster.position
                    .lat()
                    .toFixed(6)}_${cluster.position.lng().toFixed(6)}`;
                clusterOverlaysRef.current.set(clusterKey, overlay);
            }
        });
    }, [map, thresholds, pulsatingSessionId, handleClusterClickInternal]);
    const customRenderer = {
        render: ({ position }) => {
            return new google.maps.Marker({
                position,
                visible: false,
            });
        },
    };
    const createMarker = (0, react_1.useCallback)((session) => {
        const marker = new google.maps.Marker({
            position: session.point,
            icon: {
                url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAEklEQVR4nGMAAQAABQABDQottAAAAABJRU5ErkJggg==",
            },
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + 1,
        });
        marker.value = session.averageValue;
        marker.sessionId = session.id;
        marker.userData = { streamId: session.point.streamId };
        marker.clustered = false;
        marker.addListener("click", () => {
            onMarkerClickRef.current(Number(session.point.streamId), Number(session.id));
            centerMapOnMarker(session.point);
        });
        return marker;
    }, [centerMapOnMarker]);
    const handleMapInteraction = (0, react_1.useCallback)(() => {
        dispatch((0, clusterSlice_1.setVisibility)(false));
        setSelectedCluster(null);
        setClusterPosition(null);
    }, [dispatch]);
    const handleBoundsChanged = (0, react_1.useCallback)(() => {
        if (selectedCluster && map) {
            const pixelPosition = (0, getClusterPixelPosition_1.getClusterPixelPosition)(map, selectedCluster.position);
            setClusterPosition({ top: pixelPosition.y, left: pixelPosition.x });
        }
    }, [map, selectedCluster]);
    (0, mapEventListeners_1.default)(map, {
        click: handleMapInteraction,
        touchend: handleMapInteraction,
        dragstart: handleMapInteraction,
        bounds_changed: handleBoundsChanged,
    });
    const handleZoomIn = (0, react_1.useCallback)(() => {
        var _a;
        if (map && selectedCluster) {
            const bounds = new google.maps.LatLngBounds();
            (_a = selectedCluster.markers) === null || _a === void 0 ? void 0 : _a.forEach((marker) => {
                const position = "getPosition" in marker ? marker.getPosition() : marker.position;
                if (position) {
                    bounds.extend(position);
                }
            });
            map.fitBounds(bounds);
            map.panToBounds(bounds);
            google.maps.event.addListenerOnce(map, "idle", () => {
                const currentZoom = map.getZoom();
                if (currentZoom !== undefined) {
                    map.setZoom(Math.max(currentZoom - 1, 0));
                }
            });
            handleMapInteraction();
            setSelectedCluster(null);
            dispatch((0, clusterSlice_1.setVisibility)(false));
        }
    }, [map, selectedCluster, handleMapInteraction, dispatch]);
    const updateClusterOverlays = (0, react_1.useCallback)(() => {
        clusterOverlaysRef.current.forEach((overlay) => {
            const cluster = overlay.cluster;
            const markers = cluster.markers;
            const hasPulsatingSession = pulsatingSessionId !== null &&
                markers.some((marker) => marker.sessionId === pulsatingSessionId);
            overlay.setShouldPulse(hasPulsatingSession);
        });
    }, [pulsatingSessionId]);
    const isMarkerInViewport = (0, react_1.useCallback)((marker) => {
        if (!map)
            return false;
        const bounds = map.getBounds();
        return bounds ? bounds.contains(marker.getPosition()) : false;
    }, [map]);
    const updateMarkerOverlays = (0, react_1.useCallback)(() => {
        const bounds = map === null || map === void 0 ? void 0 : map.getBounds();
        markerRefs.current.forEach((marker, streamId) => {
            var _a;
            const isVisible = bounds ? bounds.contains(marker.getPosition()) : false;
            const isSelected = ((_a = marker.userData) === null || _a === void 0 ? void 0 : _a.streamId) === (selectedStreamId === null || selectedStreamId === void 0 ? void 0 : selectedStreamId.toString());
            const shouldPulse = marker.sessionId === pulsatingSessionId && !marker.clustered;
            const newColor = (0, thresholdColors_1.getColorForValue)(thresholds, marker.value);
            const existingOverlay = markerOverlays.current.get(streamId);
            const existingLabelOverlay = labelOverlays.current.get(streamId);
            const position = marker.getPosition();
            if (marker.clustered || !isVisible) {
                if (existingOverlay) {
                    existingOverlay.setMap(null);
                    markerOverlays.current.delete(streamId);
                }
                if (existingLabelOverlay) {
                    existingLabelOverlay.setMap(null);
                    labelOverlays.current.delete(streamId);
                }
            }
            else {
                // Ensure overlays are present and updated
                if (!existingOverlay) {
                    const overlay = new ((0, customMarkerOverlay_1.getCustomMarkerOverlayClass)())(position, newColor, isSelected, shouldPulse);
                    overlay.setMap(map);
                    markerOverlays.current.set(streamId, overlay);
                }
                else {
                    existingOverlay.setIsSelected(isSelected);
                    existingOverlay.setShouldPulse(shouldPulse);
                    existingOverlay.setColor(newColor);
                    existingOverlay.update();
                }
                if (!existingLabelOverlay) {
                    const labelOverlay = new ((0, customMarkerLabel_1.getLabelOverlayClass)())(position, newColor, marker.value === null ? calculatingText : marker.value, unitSymbol, isSelected, () => {
                        onMarkerClickRef.current(Number(marker.userData.streamId), Number(marker.sessionId));
                        if (position) {
                            centerMapOnMarker({ lat: position.lat(), lng: position.lng() });
                        }
                    });
                    labelOverlay.setMap(map);
                    labelOverlays.current.set(streamId, labelOverlay);
                }
                else {
                    existingLabelOverlay.update(isSelected, newColor, marker.value === null ? calculatingText : marker.value, unitSymbol);
                }
            }
        });
    }, [
        map,
        selectedStreamId,
        pulsatingSessionId,
        thresholds,
        unitSymbol,
        centerMapOnMarker,
        isLoading,
    ]);
    (0, react_1.useEffect)(() => {
        if (fixedStreamStatus === "PENDING" /* StatusEnum.Pending */)
            return;
        if (selectedStreamId === null) {
            if (!clustererRef.current && map) {
                const algorithm = new gridClusterAlgorithm_1.CustomAlgorithm();
                clustererRef.current = new markerclusterer_1.MarkerClusterer({
                    map,
                    markers: [],
                    renderer: customRenderer,
                    algorithm,
                });
                clustererRef.current.addListener("clusteringend", handleClusteringEnd);
            }
            // Create markers for all sessions if they don't exist
            memoizedSessions.forEach((session) => {
                if (!markerRefs.current.has(session.point.streamId)) {
                    const marker = createMarker(session);
                    markerRefs.current.set(session.point.streamId, marker);
                }
            });
            // Ensure clusterer is properly initialized and has all markers
            if (clustererRef.current) {
                const allMarkers = Array.from(markerRefs.current.values());
                clustererRef.current.clearMarkers();
                clustererRef.current.addMarkers(allMarkers);
                clustererRef.current.render();
            }
            updateMarkerOverlays();
            updateClusterOverlays();
        }
        else {
            if (fixedStreamData === null || fixedStreamData === void 0 ? void 0 : fixedStreamData.stream) {
                const { latitude, longitude } = fixedStreamData.stream;
                if (latitude && longitude) {
                    const fixedStreamPosition = { lat: latitude, lng: longitude };
                    // Only center on first render
                    if (!initialCenterRef.current) {
                        centerMapOnMarker(fixedStreamPosition);
                        initialCenterRef.current = true;
                    }
                    if (clustererRef.current) {
                        clustererRef.current.clearMarkers();
                        clustererRef.current.setMap(null);
                        clustererRef.current = null;
                    }
                    markerRefs.current.forEach((marker, streamIdKey) => {
                        if (streamIdKey !== selectedStreamId.toString()) {
                            marker.setMap(null);
                            markerRefs.current.delete(streamIdKey);
                            const markerOverlay = markerOverlays.current.get(streamIdKey);
                            if (markerOverlay) {
                                markerOverlay.setMap(null);
                                markerOverlays.current.delete(streamIdKey);
                            }
                            const labelOverlay = labelOverlays.current.get(streamIdKey);
                            if (labelOverlay) {
                                labelOverlay.setMap(null);
                                labelOverlays.current.delete(streamIdKey);
                            }
                        }
                    });
                    const selectedMarker = markerRefs.current.get(selectedStreamId.toString());
                    if (!selectedMarker) {
                        const session = memoizedSessions.find((session) => session.point.streamId === selectedStreamId.toString());
                        if (session) {
                            const newMarker = createMarker(session);
                            markerRefs.current.set(session.point.streamId, newMarker);
                            newMarker.setMap(map);
                            const value = session.averageValue;
                            const color = (0, thresholdColors_1.getColorForValue)(thresholds, value);
                            const newOverlay = new ((0, customMarkerOverlay_1.getCustomMarkerOverlayClass)())(new google.maps.LatLng(latitude, longitude), color, true, false);
                            newOverlay.setMap(map);
                            markerOverlays.current.set(session.point.streamId, newOverlay);
                            const newLabelOverlay = new ((0, customMarkerLabel_1.getLabelOverlayClass)())(new google.maps.LatLng(latitude, longitude), color, value === null ? calculatingText : value, unitSymbol, true, () => {
                                onMarkerClickRef.current(Number(session.point.streamId), Number(session.id));
                                centerMapOnMarker(fixedStreamPosition);
                            });
                            newLabelOverlay.setMap(map);
                            labelOverlays.current.set(session.point.streamId, newLabelOverlay);
                        }
                    }
                    clusterOverlaysRef.current.forEach((overlay) => overlay.setMap(null));
                    clusterOverlaysRef.current.clear();
                }
            }
        }
    }, [
        selectedStreamId,
        fixedStreamStatus,
        fixedStreamData,
        map,
        customRenderer,
        handleClusteringEnd,
        updateMarkerOverlays,
        updateClusterOverlays,
        memoizedSessions,
        createMarker,
        thresholds,
        unitSymbol,
        centerMapOnMarker,
    ]);
    (0, react_1.useEffect)(() => {
        if (!map || !clustererRef.current)
            return;
        const bounds = map.getBounds();
        const updatedMarkers = [];
        const markersToRemove = [];
        memoizedSessions.forEach((session) => {
            let marker = markerRefs.current.get(session.point.streamId);
            if (!marker) {
                marker = createMarker(session);
                markerRefs.current.set(session.point.streamId, marker);
                if (bounds === null || bounds === void 0 ? void 0 : bounds.contains(marker.getPosition())) {
                    updatedMarkers.push(marker);
                }
            }
            else {
                marker.setPosition(session.point);
                marker.value = session.averageValue;
                marker.sessionId = session.id;
            }
        });
        // Identify markers to remove
        markerRefs.current.forEach((marker, streamId) => {
            if (!sessions.some((session) => session.point.streamId === streamId)) {
                markersToRemove.push(marker);
                markerRefs.current.delete(streamId);
            }
        });
        // Remove markers no longer in the sessions array
        if (markersToRemove.length > 0) {
            clustererRef.current.removeMarkers(markersToRemove);
            markersToRemove.forEach((marker) => marker.setMap(null));
        }
        // Add new markers
        if (updatedMarkers.length > 0) {
            clustererRef.current.addMarkers(updatedMarkers);
        }
        // Remove overlays for removed markers
        markersToRemove.forEach((marker) => {
            const streamId = marker.userData.streamId;
            const overlay = markerOverlays.current.get(streamId);
            if (overlay) {
                overlay.setMap(null);
                markerOverlays.current.delete(streamId);
            }
            const labelOverlay = labelOverlays.current.get(streamId);
            if (labelOverlay) {
                labelOverlay.setMap(null);
                labelOverlays.current.delete(streamId);
            }
            marker.setMap(null);
        });
        // Force clusterer update
        clustererRef.current.render();
        updateMarkerOverlays();
        updateClusterOverlays();
    }, [
        sessions,
        map,
        createMarker,
        thresholds,
        unitSymbol,
        pulsatingSessionId,
        updateMarkerOverlays,
        updateClusterOverlays,
        memoizedSessions,
        isLoading,
    ]);
    (0, react_1.useEffect)(() => {
        if (clustererRef.current) {
            clustererRef.current.addListener("clusteringend", () => {
                markerRefs.current.forEach((marker) => {
                    marker.clustered = false;
                });
                const clusters = clustererRef.current &&
                    // @ts-ignore - clusters
                    clustererRef.current.clusters;
                clusterOverlaysRef.current.forEach((overlay) => {
                    overlay.setMap(null);
                });
                clusterOverlaysRef.current.clear();
                if (!clusters)
                    return;
                clusters.forEach((cluster) => {
                    if (cluster.markers && cluster.markers.length > 1) {
                        cluster.markers.forEach((marker) => {
                            marker.clustered = true;
                        });
                        const markers = cluster.markers;
                        const values = markers.map((marker) => marker.value || 0);
                        const average = values.reduce((sum, value) => sum + value, 0) / values.length;
                        const color = (0, thresholdColors_1.getColorForValue)(thresholds, average);
                        const hasPulsatingSession = pulsatingSessionId !== null &&
                            markers.some((marker) => marker.sessionId === pulsatingSessionId);
                        const overlay = new ((0, clusterOverlay_1.getClusterOverlayClass)())(cluster, color, hasPulsatingSession, map, handleClusterClickInternal);
                        const clusterKey = `${cluster.position
                            .lat()
                            .toFixed(6)}_${cluster.position.lng().toFixed(6)}`;
                        clusterOverlaysRef.current.set(clusterKey, overlay);
                    }
                });
            });
        }
    }, [
        map,
        thresholds,
        sessions,
        pulsatingSessionId,
        handleClusterClickInternal,
        isLoading,
    ]);
    (0, react_1.useEffect)(() => {
        updateMarkerOverlays();
        updateClusterOverlays();
    }, [
        pulsatingSessionId,
        selectedStreamId,
        sessions,
        updateMarkerOverlays,
        updateClusterOverlays,
    ]);
    (0, react_1.useEffect)(() => {
        if (hoverStreamId) {
            const hoveredSession = memoizedSessions.find((session) => Number(session.point.streamId) === hoverStreamId);
            if (hoveredSession) {
                setHoverPosition(hoveredSession.point);
            }
        }
        else {
            setHoverPosition(null);
        }
    }, [hoverStreamId, memoizedSessions]);
    (0, react_1.useEffect)(() => {
        if (markerRefs.current.size >= memoizedSessions.length) {
            dispatch((0, markersLoadingSlice_1.setMarkersLoading)(false));
        }
    }, [dispatch, sessions.length, memoizedSessions.length]);
    // Add cleanup function
    const clearAllMarkersAndClusters = (0, react_1.useCallback)(() => {
        // Clear clusterer
        if (clustererRef.current) {
            clustererRef.current.clearMarkers();
            clustererRef.current.setMap(null);
            clustererRef.current = null;
        }
        // Clear all marker overlays
        markerOverlays.current.forEach((overlay) => {
            overlay.setMap(null);
        });
        markerOverlays.current.clear();
        // Clear all label overlays
        labelOverlays.current.forEach((overlay) => {
            overlay.setMap(null);
        });
        labelOverlays.current.clear();
        // Clear all cluster overlays
        clusterOverlaysRef.current.forEach((overlay) => {
            overlay.setMap(null);
        });
        clusterOverlaysRef.current.clear();
        // Clear all markers
        markerRefs.current.forEach((marker) => {
            marker.setMap(null);
        });
        markerRefs.current.clear();
        // Reset state
        setSelectedCluster(null);
        setClusterPosition(null);
        setHoverPosition(null);
        // Reset the initial center ref
        initialCenterRef.current = false;
    }, []);
    // Watch for mode changes using currentUserSettings
    const previousUserSettingsRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const currentMode = currentUserSettings;
        const previousMode = previousUserSettingsRef.current;
        // Clear markers when switching to/from timelapse view
        if (previousMode &&
            ((previousMode === userStates_1.UserSettings.TimelapseView &&
                currentMode !== userStates_1.UserSettings.TimelapseView) ||
                (previousMode !== userStates_1.UserSettings.TimelapseView &&
                    currentMode === userStates_1.UserSettings.TimelapseView))) {
            clearAllMarkersAndClusters();
        }
        previousUserSettingsRef.current = currentMode;
        // Cleanup on unmount
        return () => {
            clearAllMarkersAndClusters();
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (clustererRef.current && map) {
            // Force re-clustering
            clustererRef.current.render();
            handleClusteringEnd();
        }
    }, [map === null || map === void 0 ? void 0 : map.getZoom(), currentUserSettings, handleClusteringEnd]);
    (0, react_1.useEffect)(() => {
        if (map) {
            const listener = map.addListener("idle", updateMarkerOverlays);
            return () => {
                google.maps.event.removeListener(listener);
            };
        }
    }, [map, updateMarkerOverlays]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        hoverPosition && react_1.default.createElement(HoverMarker_1.default, { position: hoverPosition }),
        clusterPosition &&
            selectedCluster &&
            (clusterDataLoading ? (react_1.default.createElement(ClusterInfo_1.ClusterInfoLoading, { position: clusterPosition, visible: true })) : (react_1.default.createElement(ClusterInfo_1.ClusterInfo, { color: (0, thresholdColors_1.getColorForValue)(thresholds, clusterAverage), average: clusterAverage, numberOfSessions: clusterSize, handleZoomIn: handleZoomIn, position: clusterPosition, visible: clusterVisible })))));
}
exports.FixedMarkers = FixedMarkers;
